import { stripTrailingSlash } from './normalizePathname';

const addLocationOriginToUrl = (url, origin) => {
  // defaulting the argument would break imports on server-side
  if (typeof origin === 'undefined' && typeof window !== 'undefined') {
    origin = window.location.origin;
  }
  const httpProtocolMatch = url.match(/https?:\/\//);
  if (httpProtocolMatch && httpProtocolMatch.index === 0) {
    return url;
  }

  return `${stripTrailingSlash(origin)}${url}`;
};

export default addLocationOriginToUrl;
